<div class="field-header">
  <div class="option">Dissatisfied</div>
  <div class="option">Indifferent</div>
  <div class="option">Satisfied</div>
  <div class="option">Very satisfied</div>
</div>
